<template>
    <NxSelect
    :value="localValue"
    :options="listOptions"
    labelText="Prognóstico:"
    id="selectPrognostico"
    placeholder="Selecione o(s) Prognóstico(s)"
    :multiple="true"
    @update:value="handleValueUpdate"
  ></NxSelect>
</template>
<script>
import { toast } from '@/shared/utils/UIHelper'
import { useReactiveModelMixin } from '../../mixins'
import PrognosticoRepository from '@/shared/http/repositories/configurations/prognostico.js'

export default {
  name: 'NxSelectAjuizamentoPrognostico',
  mixins: [ useReactiveModelMixin('value') ],
  data () {
    return {
      listOptions: [],
      selected: null
    }
  },
  created () {
    this.onLoadPrognosticos()
  },
  methods: {
    onLoadPrognosticos () {
      PrognosticoRepository.GetAll()
        .then((response) => {
          let result = response.data.content
            .map((x) => ({'value': x.id, 'text': x.nome}))
          this.listOptions = result
        })
        .catch((err) => {
          toast.error('Não foi possível carregar a lista de Prognósticos', 'Erro')
          console.error(err)
        })
    },
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectAjuizamentoPrognostico.vue